import { all } from 'redux-saga/effects';

import saga from '@/services/sagas';

export const createRootSaga = () =>
    function* rootSaga() {
        yield all([saga()]);
    };
